import { Link } from "react-router-dom";
import { useAppSelector } from "../../app/hooks";
import MiWriteLogo from "../../assets/MiWriteLogo";
import AccessibilityPopover from "../accessibility/AccessibilityPopover";
import NotificationPopover from "../notifications/NotificationPopover";
import SupportMenu from "../support/SupportMenu";
import CollapsibleNavbar from "./CollapsibleNavbar";
import ProfileMenu from "./ProfileMenu";
import UtahComposeLogo from "./UtahComposeLogo";

export default function Header() {
	const { config } = useAppSelector((state) => state.site);
	const { course, requiresAccountConfirmation, bypassTermsOfService } = useAppSelector(
		(state) => state.user
	);

	function Navbar() {
		return <CollapsibleNavbar isCourseActive={course?.isActive} showLeftNav={!!course} />;
	}

	return (
		<header className="bg-primary-700 print:hidden">
			<div className="mx-auto max-w-screen-2xl px-4 sm:px-6 lg:px-8">
				<div className="relative flex items-center py-3 justify-between border-b border-white/20">
					<Link
						to={
							!bypassTermsOfService
								? "/termsOfService"
								: requiresAccountConfirmation
									? "/myAccount"
									: "/home"
						}>
						{config?.isUtahComposeSite ? (
							<UtahComposeLogo />
						) : (
							<MiWriteLogo className="h-12 text-white" />
						)}
					</Link>
					{bypassTermsOfService && (
						<div className="flex justify-center space-x-6">
							<AccessibilityPopover />
							<NotificationPopover />
							<SupportMenu />
							<ProfileMenu />
						</div>
					)}
				</div>
				<div className="border-b border-white/20">
					<Navbar />
				</div>
			</div>
		</header>
	);
}
